import { Link, useParams } from "react-router-dom";
import { DEFAULT_LOCALE } from "../../i18n/locales";
import MarkdownContent from "../../components/markdown/MarkdownContent";
import React from "react";
import Share from "../../components/share/Share";
import content from "../../generated/content.json";
import { useLocale } from "../../i18n/LocaleProvider";
import { useT } from "../../i18n/useT";

const ProjectPost = () => {
  const { lang } = useLocale();
  const t = useT();
  const { slug } = useParams();
  const localized = (content.projects?.[lang] || []).find(
    (p) => p.slug === slug
  );
  const fallback = (content.projects?.[DEFAULT_LOCALE] || []).find(
    (p) => p.slug === slug
  );
  const project = localized || fallback;

  if (!project) {
    return (
      <section className="container py-5 mt-5">
        <h1>{t("projects.notFound")}</h1>
        <p>
          <Link to={`/${lang}/projects`}>{t("projects.backToList")}</Link>
        </p>
      </section>
    );
  }

  const fm = project.frontmatter;
  return (
    <section className="container py-5 mt-5">
      {!localized && (
        <div className="alert alert-info">
          {t("projects.translationMissing")}
        </div>
      )}
      <h1>{fm.title}</h1>
      {fm.role && <div className="text-secondary mb-4">{fm.role}</div>}
      <MarkdownContent html={project.html} />
      <Share
        path={`/${lang}/projects/${project.slug}`}
        title={fm.title}
        heading={t("projects.shareTitle")}
      />
      <p className="mt-5">
        <Link to={`/${lang}/projects`}>{t("projects.backToList")}</Link>
      </p>
    </section>
  );
};

export default ProjectPost;
